<template>
	<div class="toC">
		<van-nav-bar v-if="showNav" title="伟东云职业教育生态平台" left-arrow @click-left="$router.back()" fixed placeholder />

		<div class="header">
			<img src="../../../assets/images/other/cbg.jpg" alt="" />
		</div>

		<div class="contentWrapper">
            <div class="content">
                <div class="module">
                    <div class="title">
                        <svg-icon icon-class="tl"></svg-icon>
                        <span class="text1">我们的服务</span>
                        <svg-icon icon-class="tr"></svg-icon>
                    </div>
                    <div class="text2">
                        以人才产业应用为导向，为政府协会、职业教育上下游产业、院校等各方，提供全链条服务
                    </div>
                    <div class="server">
                        <div class="server_item">
                            <div class="item_left">
                                <svg-icon icon-class="xjn"></svg-icon>
                            </div>
                            <div class="item_right">
                                <div class="right_top">学技能</div>
                                <div class="right_bottom">多领域实战技能培训课程，满足学习发展需求。</div>
                            </div>
                        </div>
                        <div class="server_item">
                            <div class="item_left">
                                <svg-icon icon-class="zgz"></svg-icon>
                            </div>
                            <div class="item_right">
                                <div class="right_top">找工作</div>
                                <div class="right_bottom">海量高薪职位为您精准匹配，躺着找到满意工作。</div>
                            </div>
                        </div>
                        <div class="server_item">
                            <div class="item_left">
                                <svg-icon icon-class="zrc"></svg-icon>
                            </div>
                            <div class="item_right">
                                <div class="right_top">招人才</div>
                                <div class="right_bottom">便捷创建用工需求，帮助企业快速高效找到合适人才。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="module module2">
                    <div class="title">
                        <svg-icon icon-class="tl"></svg-icon>
                        <span class="text1">想要联系我们</span>
                        <svg-icon icon-class="tr"></svg-icon>
                    </div>
                    <div class="text2">
                        如果您想加入我们，请留下您的联系方式
                    </div>
                    <div class="form">
                        <van-form @submit="onSubmit">
                            <van-field v-model="formData.toCMobile" name="手机号" placeholder="请输入手机号" clearable :border="false" />
                            <van-field v-model="formData.toCIndustry" name="行业" placeholder="请输入所属行业" clearable :border="false" />
                            <van-field readonly clickable :value="formData.toCAddress" @click="handleShowArea" placeholder="请选择省、市、区县" :border="false" />

                            <van-popup v-model="showArea" position="bottom" get-container="body">
                                <van-area title="地址" :area-list="cityList" @confirm="onConfirm" @cancel="showArea = false" />
                            </van-popup>

                            <div class="btn" @click="onSubmit">
                                <span>提交</span>
                            </div>
                        </van-form>
                    </div>
                </div>
                <div class="module module3">
                    <div class="title">
                        <svg-icon icon-class="tl"></svg-icon>
                        <span class="text1">一键体验专业服务</span>
                        <svg-icon icon-class="tr"></svg-icon>
                    </div>
                    <div class="text2">
                        赶快来下载APP，进一步了解我们吧
                    </div>
                    <div class="app">
                        <img src="../../../assets/images/other/capp.png" alt="" />
                    </div>
                    <div class="btn download" @click="toDonwnload">
                        <span>立即下载</span>
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { isPhone } from '../../../utils/validate'
export default {
	name: 'toC',
	data() {
		return {
            isWechat: false,
            isIos: false,
			showArea: false,
			formData: {
				toCMobile: '',
				toCIndustry: '',
				toCAddress: '',
				source: '', //来源 1、咚咚燕 2、工信 3、应急 4、海纳易学
			},
			cityList: {
				province_list: {},
				city_list: {},
				county_list: {},
			}, // 数据格式见 Area 组件文档
			androidApk: '',
		}
    },
    computed:{
        showNav(){
            if(this.formData.source == 1){//咚咚燕app隐藏导航头
                return false
            }else{
                return true
            }
        }
    },
	mounted() {
        const ua = window.navigator.userAgent.toLowerCase()
        this.isIos = /iphone|ipad|ipod/.test(ua)
        this.isWechat = ua.indexOf('micromessenger') !== -1
        console.log('isIos--------', this.isIos)
        console.log('isWechat--------', this.isWechat)
        if (this.$route.query.source) {
            this.formData.source = this.$route.query.source
        }
        if (this.$route.query.phone) {
            this.formData.toCMobile = this.$route.query.phone
        } else if (localStorage.getItem('WDuserInfo')){
            let userInfo = JSON.parse(localStorage.getItem('WDuserInfo'))
            this.formData.toCMobile = userInfo.phone
        }
		this.getRegionList()
		this.getAndroidApk()
	},
	methods: {
		getRegionList() {
			this.$api.usercenter.getTree({ type: 1 }).then((res) => {
				if (res.success && res.data) {
					let filterArr = res.data
					// 切换成vant省市组件格式
					filterArr.map((item) => {
						this.cityList.province_list[item.code] = item.name
						item.children.map((province) => {
							this.cityList.city_list[province.code] = province.name
							;(province.children || []).map((county) => {
								this.cityList.county_list[county.code] = county.name
							})
						})
					})
				}
			})
		},
		getAndroidApk() {
			axios
				.post('https://hrss-api.wdeduc.com/c/v1/client/versionInfo/findByVersionNum', {
					client: 2,
				})
				.then((res) => {
					if (res.data.success) {
						this.androidApk = res.data.data && res.data.data.upgradeAddr
						console.log('----------', this.androidApk)
					}
				})
		},
		handleShowArea() {
			this.showArea = true
		},
		// 省市选择
		onConfirm(values) {
			this.formData.toCAddress = values
				.filter((item) => !!item)
				.map((item) => item.name)
				.join(',')
			this.showArea = false
		},
		onSubmit(values) {
			if (!isPhone.test(this.formData.toCMobile)) {
				this.$toast('请输入正确的手机号！')
				return
			}
			this.$api.editForm.saveDynamicData(this.formData).then((res) => {
				if (res.success && res.data) {
					this.$toast('提交成功！')
				}
			})
		},
		toDonwnload() {
			if (this.isWechat) {
				this.$toast('可在浏览器中打开此网页来下载文件')
				return
            }
            const url = this.isIos ? 'https://apps.apple.com/cn/app/%E4%BC%9F%E4%B8%9C%E4%BA%91/id1616598418' : this.androidApk
            if(this.isIos){
                window.location.href = url
            }else{
                if(this.formData.source == 1){
                    console.log('window.SignJSBright-------',window.SignJSBright)
                    
                    window.SignJSBright.downWdApk(url)
                }else{
                    window.open(url)
                }
            }
			console.log('download-------', url)
		},
	},
}
</script>

<style scoped lang="less">
@import '../asset/css/toc.less';
</style>
